import React from "react";
import { Box } from "theme-ui";

interface TDProps {
  children: React.ReactNode;
}

function TD(props: TDProps) {
  return (
    <Box
      as="td"
      {...props}
      sx={{
        borderBottom: "1px solid",
        borderBottomColor: "#ededed",
        color: "#000",
        fontSize: "14px",
        fontWeight: 400,
        padding: "8px 0",
        textAlign: "center",
        verticalAlign: "middle",
      }}
    />
  );
}

export default TD;
